import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import Card from 'syf-component-library/ui/atoms/Card/Card';
export const StyledCard = styled(Card) `
  @media ${mediaQueries.lessThanMedium} {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`;
//# sourceMappingURL=subcomponents.js.map